<template>
  <component :is="appBarComponent" />
</template>

<script>
import AppBarDesktop from "@/views/dashboard/components/core/appbar/desktop/AppBarDesktop.vue";
import AppBarMobile from "@/views/dashboard/components/core/appbar/mobile/AppBarMobile.vue";

export default {
  name: "AppBar",
  components: {
    AppBarDesktop,
    AppBarMobile,
  },
  computed: {
    appBarComponent() {
      return this.isMobile ? "AppBarMobile" : "AppBarDesktop";
    },
  },
};
</script>
